module.exports = __webpack_public_path__ + "static/media/laserbeam.1fb0fcc2.png";